import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";

const store = configureStore({
  reducer: rootReducer,
  // Redux Toolkit automatically includes:
  // - redux-thunk middleware
  // - Redux DevTools Extension integration
  // - Immutability and serializability checks in development
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // You can customize middleware options here if needed
      serializableCheck: {
        // Ignore these action types for serialization checks
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export default store;
